module.exports = __webpack_public_path__ + "img/woman_placeholder_10.e3e134c0.jpg";